"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownComponent = exports.ToggleComponent = exports.TextFieldComponent = void 0;
const BaseComponent_1 = require("./BaseComponent");
/**
 * 文本输入框组件
 * 提供单行文本输入功能
 */
class TextFieldComponent extends BaseComponent_1.BaseComponent {
    constructor(label, defaultValue = '', container) {
        super(container);
        this.changeCallbacks = [];
        this._label = label;
        this._value = defaultValue;
        this._placeholder = '';
        this._maxLength = -1;
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置输入值
     */
    get value() {
        return this._value;
    }
    set value(v) {
        if (this._value !== v) {
            this._value = v;
            this.inputElement.value = v;
            this.notifyChange();
        }
    }
    /**
     * 获取/设置占位符文本
     */
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(v) {
        this._placeholder = v;
        this.inputElement.placeholder = v;
    }
    /**
     * 获取/设置最大长度
     */
    get maxLength() {
        return this._maxLength;
    }
    set maxLength(v) {
        this._maxLength = v;
        if (v > 0) {
            this.inputElement.maxLength = v;
        }
        else {
            this.inputElement.removeAttribute('maxlength');
        }
    }
    /**
     * 获取/设置标签文本
     */
    get label() {
        return this._label;
    }
    set label(v) {
        this._label = v;
        this.labelElement.textContent = v;
    }
    /**
     * 聚焦到输入框
     */
    focus() {
        this.inputElement.focus();
    }
    /**
     * 失去焦点
     */
    blur() {
        this.inputElement.blur();
    }
    /**
     * 清空内容
     */
    clear() {
        this.value = '';
    }
    /**
     * 注册值变化回调
     */
    onChange(callback) {
        this.changeCallbacks.push(callback);
    }
    createElement() {
        this.wrapperElement = document.createElement('div');
        this.labelElement = document.createElement('label');
        this.inputElement = document.createElement('input');
        this.element = this.wrapperElement;
    }
    render() {
        // 设置样式类
        this.wrapperElement.className = 'nexus-textfield';
        this.labelElement.className = 'nexus-textfield-label';
        this.inputElement.className = 'nexus-textfield-input';
        // 设置属性
        this.inputElement.type = 'text';
        this.inputElement.value = this._value;
        this.labelElement.textContent = this._label;
        if (this._placeholder) {
            this.inputElement.placeholder = this._placeholder;
        }
        if (this._maxLength > 0) {
            this.inputElement.maxLength = this._maxLength;
        }
        // 组装DOM结构
        this.wrapperElement.appendChild(this.labelElement);
        this.wrapperElement.appendChild(this.inputElement);
        this.container.appendChild(this.wrapperElement);
    }
    bindEvents() {
        this.inputElement.addEventListener('input', (e) => {
            const target = e.target;
            this._value = target.value;
            this.notifyChange();
        });
        this.inputElement.addEventListener('change', (e) => {
            const target = e.target;
            this._value = target.value;
            this.notifyChange();
        });
    }
    notifyChange() {
        this.changeCallbacks.forEach(callback => callback(this._value));
    }
    updateEnabledState() {
        super.updateEnabledState();
        if (this.inputElement) {
            this.inputElement.disabled = !this.enabled;
        }
    }
}
exports.TextFieldComponent = TextFieldComponent;
/**
 * 切换开关组件
 * 提供布尔值的切换功能
 */
class ToggleComponent extends BaseComponent_1.BaseComponent {
    constructor(label, defaultValue = false, container) {
        super(container);
        this.changeCallbacks = [];
        this._label = label;
        this._value = defaultValue;
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置选中状态
     */
    get value() {
        return this._value;
    }
    set value(v) {
        if (this._value !== v) {
            this._value = v;
            this.inputElement.checked = v;
            this.notifyChange();
        }
    }
    /**
     * 获取/设置标签文本
     */
    get label() {
        return this._label;
    }
    set label(v) {
        this._label = v;
        this.labelElement.textContent = v;
    }
    /**
     * 注册值变化回调
     */
    onChange(callback) {
        this.changeCallbacks.push(callback);
    }
    createElement() {
        this.wrapperElement = document.createElement('div');
        this.labelElement = document.createElement('label');
        this.inputElement = document.createElement('input');
        this.element = this.wrapperElement;
    }
    render() {
        // 设置样式类
        this.wrapperElement.className = 'nexus-toggle';
        this.labelElement.className = 'nexus-toggle-label';
        this.inputElement.className = 'nexus-toggle-input';
        // 设置属性
        this.inputElement.type = 'checkbox';
        this.inputElement.checked = this._value;
        this.labelElement.textContent = this._label;
        // 组装DOM结构
        this.wrapperElement.appendChild(this.inputElement);
        this.wrapperElement.appendChild(this.labelElement);
        this.container.appendChild(this.wrapperElement);
    }
    bindEvents() {
        this.inputElement.addEventListener('change', (e) => {
            const target = e.target;
            this._value = target.checked;
            this.notifyChange();
        });
    }
    notifyChange() {
        this.changeCallbacks.forEach(callback => callback(this._value));
    }
    updateEnabledState() {
        super.updateEnabledState();
        if (this.inputElement) {
            this.inputElement.disabled = !this.enabled;
        }
    }
}
exports.ToggleComponent = ToggleComponent;
/**
 * 下拉选择框组件
 * 提供多选项的选择功能
 */
class DropdownComponent extends BaseComponent_1.BaseComponent {
    constructor(label, options, defaultValue, container) {
        super(container);
        this.changeCallbacks = [];
        this._label = label;
        this._options = Array.isArray(options) ? [...options] : [];
        this._selectedIndex = defaultValue !== undefined && this._options.length > 0 ? this._options.indexOf(defaultValue) : 0;
        this._value = this._selectedIndex >= 0 ? this._options[this._selectedIndex] : (this._options.length > 0 ? this._options[0] : undefined);
        BaseComponent_1.NexusGUIManager.registerComponent(this);
    }
    /**
     * 获取/设置选中值
     */
    get value() {
        return this._value;
    }
    set value(v) {
        const index = this._options.indexOf(v);
        if (index >= 0 && this._selectedIndex !== index) {
            this._selectedIndex = index;
            this._value = v;
            this.selectElement.selectedIndex = index;
            this.notifyChange();
        }
    }
    /**
     * 获取/设置选项列表
     */
    get options() {
        return [...this._options];
    }
    set options(v) {
        this._options = Array.isArray(v) ? [...v] : [];
        this.updateOptions();
        // 重新设置选中值
        if (this._selectedIndex >= this._options.length) {
            this.selectedIndex = this._options.length > 0 ? 0 : -1;
        }
    }
    /**
     * 获取/设置选中索引
     */
    get selectedIndex() {
        return this._selectedIndex;
    }
    set selectedIndex(v) {
        if (v >= 0 && v < this._options.length && this._selectedIndex !== v) {
            this._selectedIndex = v;
            this._value = this._options[v];
            this.selectElement.selectedIndex = v;
            this.notifyChange();
        }
    }
    /**
     * 获取/设置标签文本
     */
    get label() {
        return this._label;
    }
    set label(v) {
        this._label = v;
        this.labelElement.textContent = v;
    }
    /**
     * 注册值变化回调
     */
    onChange(callback) {
        this.changeCallbacks.push(callback);
    }
    createElement() {
        this.wrapperElement = document.createElement('div');
        this.labelElement = document.createElement('label');
        this.selectElement = document.createElement('select');
        this.element = this.wrapperElement;
    }
    render() {
        // 设置样式类
        this.wrapperElement.className = 'nexus-dropdown';
        this.labelElement.className = 'nexus-dropdown-label';
        this.selectElement.className = 'nexus-dropdown-select';
        // 设置标签
        this.labelElement.textContent = this._label;
        // 更新选项
        this.updateOptions();
        // 组装DOM结构
        this.wrapperElement.appendChild(this.labelElement);
        this.wrapperElement.appendChild(this.selectElement);
        this.container.appendChild(this.wrapperElement);
    }
    bindEvents() {
        this.selectElement.addEventListener('change', (e) => {
            const target = e.target;
            this._selectedIndex = target.selectedIndex;
            this._value = this._options[this._selectedIndex];
            this.notifyChange();
        });
    }
    updateOptions() {
        if (!this.selectElement)
            return;
        // 清空现有选项
        this.selectElement.innerHTML = '';
        // 添加新选项 - 添加防御性编程
        if (Array.isArray(this._options)) {
            this._options.forEach((option, index) => {
                const optionElement = document.createElement('option');
                optionElement.value = index.toString();
                optionElement.textContent = typeof option === 'string' ? option : JSON.stringify(option);
                this.selectElement.appendChild(optionElement);
            });
        }
        // 设置选中项
        if (this._selectedIndex >= 0 && this._selectedIndex < this._options.length) {
            this.selectElement.selectedIndex = this._selectedIndex;
        }
    }
    notifyChange() {
        this.changeCallbacks.forEach(callback => callback(this._value));
    }
    updateEnabledState() {
        super.updateEnabledState();
        if (this.selectElement) {
            this.selectElement.disabled = !this.enabled;
        }
    }
}
exports.DropdownComponent = DropdownComponent;
